import URI from 'urijs'

export const addHttpToUrl = (url) => {
  try {
    const uri = new URI(url)

    if (!uri.protocol()) {
      uri.protocol('http')
    }

    return uri.toString()
  } catch (e) {
    return url
  }
}

const testLocation = (regExp, url) => {
  const results = regExp.exec(url)

  if (results && results[1]) {
    return +results[1]
  }

  return null
}

const cardLocationRegExp = new RegExp('^' + window.location.origin + '/card/(\\d+)', 'i')
export const isCardLocation = (url) => testLocation(cardLocationRegExp, url)
